import { BillingViewWrapper } from "./data/BillingView";
import { RefundViewWrapper } from "./data/Refundview";
import { ReportVieWrapper } from "./data/ReportView";
import { BillingViewCpnWeb } from "./web/BillView";
import { RefundViewCpnWeb } from "./web/RefoundView";
import { ReportViewCpnWeb } from "./web/ReportView";

import { BillViewMobile } from "./mobile/BillView";
import { RefundViewMobileCpn } from "./mobile/RefoundView";
import { ReportViewMobile } from "./mobile/ReportView";

export function ReportView({ isMobile }) {
  return (
    <ReportVieWrapper>
      {/* @ts-ignore */}
      {isMobile ? <ReportViewMobile /> : <ReportViewCpnWeb />}
    </ReportVieWrapper>
  );
}

export function RefundView({ isMobile }) {
  return (
    <RefundViewWrapper>
      {/* @ts-ignore */}
      {isMobile ? <RefundViewMobileCpn /> : <RefundViewCpnWeb />}
    </RefundViewWrapper>
  );
}

export function BillingView({ isMobile }) {
  return (
    <BillingViewWrapper>
      {/* @ts-ignore */}
      {isMobile ? <BillViewMobile /> : <BillingViewCpnWeb />}
    </BillingViewWrapper>
  );
}

